import { SET_FLOORS } from "../../types";

const setOilFloors = (oilFloors) => (dispatch) => {
  dispatch({ type: SET_FLOORS, oilFloors });
};

export { setOilFloors };
